import { OrderStatus } from "../enums";

/** Enquiry statuses before the customer has responded to the draft estimate. */
const PRE_DRAFT_ESTIMATE_RESPONSE_STATUSES: string[] = [
  OrderStatus.NEW,
  OrderStatus.ACK,
  OrderStatus.PART_CONVERSION_STARTED,
  OrderStatus.PART_CONVERSION_COMPLETED,
  OrderStatus.DRAFT_ESTIMATE_SHARED,
];

export const SUPPLIER_DISCOVERY_AWAITING_DRAFT_ESTIMATE_RESPONSE_HINT =
  "Supplier discovery opens once the customer responds to the draft estimate";

const isEnquiryRoot = (order: any): boolean =>
  order?.requireEstimate === true &&
  Boolean(order?._id) &&
  String(order?.rootOrderId) === String(order?._id);

/**
 * True when supplier discovery must stay disabled because the enquiry needs a
 * price estimate (`requirePriceEstimate`) and the customer has not responded to
 * the draft estimate yet: up to DRAFT_ESTIMATE_SHARED, including a customer
 * hold taken from DRAFT_ESTIMATE_SHARED. From DRAFT_ESTIMATE_RESPONDED on it is
 * false. Enquiries without the flag and child orders are never affected, so
 * the existing discovery rules apply to them unchanged.
 */
export const isSupplierDiscoveryAwaitingDraftEstimateResponse = (
  order: any,
): boolean => {
  if (order?.requirePriceEstimate !== true || !isEnquiryRoot(order)) {
    return false;
  }
  if (PRE_DRAFT_ESTIMATE_RESPONSE_STATUSES.includes(order.orderStatus)) {
    return true;
  }
  return (
    order.orderStatus === OrderStatus.CUSTOMER_HOLD &&
    order.metaInfo?.customerHoldReturnState ===
      OrderStatus.DRAFT_ESTIMATE_SHARED
  );
};
